import { HIDDEN_SELECTOR } from '../keyboard-nav-support';

function matchMenuItem(el, { upperValue, multiselect, excludeId }) {
  if (excludeId && el.id === excludeId) return;

  let element = multiselect ? el.parentElement : el;
  if (!element) return;

  let ucContent = element.textContent.trim().toUpperCase();

  if (ucContent.includes(upperValue)) {
    element.classList.remove(HIDDEN_SELECTOR);
    return el;
  }

  if (!element.classList.contains(HIDDEN_SELECTOR)) {
    element.classList.add(HIDDEN_SELECTOR);
  }
}

/**
 * Default number of menu items at (or above) which an in-menu search field is shown.
 */
export const MENU_SEARCH_THRESHOLD_DEFAULT = 15;

/**
 * Simple, case-insensitive text filter shared by every menu-based dropdown.
 *
 * Toggles the `HIDDEN_SELECTOR` class on each item's display element based on whether
 * its text content includes the provided value, and returns the list of matching items.
 *
 * @param {Element[]} elements the navigable item elements to filter
 * @param {string} value the current search/filter value
 * @param {object} [options]
 * @param {boolean} [options.multiselect] when true, the parent element of each item is toggled
 * @param {string} [options.excludeId] id of an item to skip (e.g. a "select all" option)
 * @returns {Element[]} the matching item elements
 */
export function filterMenuItemsByText(
  elements = [],
  value = '',
  { multiselect = false, excludeId } = {}
) {
  let upperValue = (value ?? '').toUpperCase();

  return elements.filter(el => matchMenuItem(el, { upperValue, multiselect, excludeId }));
}
